module.exports = __webpack_public_path__ + "static/media/brand.8f0475fd.png";